module.exports = __webpack_public_path__ + "../../static/vue/img/start_512.c2879da4.jpg";